import { useState } from 'react';
import { type CustomImageLink, type CustomTextLink } from '@/data/footer-assets';
import { useIntl } from 'react-intl';
//styles
import styles from './custom-link.module.scss';

export interface CustomLinkProps {
  link: CustomTextLink | CustomImageLink;
  linkStyle?: any;
}

const CustomLink = ({ link, linkStyle }: CustomLinkProps) => {
  const [selectedImage, setSelectedImage] = useState(link.type === 'image' ? link.image : '');
  const { formatMessage, locale } = useIntl();

  return (
    <div className={styles.customLinkContainer}>
      <a
        className={styles.customLinkAnchor}
        {...(link.type === 'link' ? link.anchorProps[locale as 'en' | 'fr'] : link.anchorProps)}
        aria-label={link.type === 'image' ? link.ariaLabel : undefined}
      >
        {/* WARN: using a NextJS image here is known as a possible cause of a bug in dev (https://gitlab.lblw.ca/sdm/sdm-frontshop/-/merge_requests/73) */}
        {link.type === 'link' ? (
          formatMessage({ id: link.textId })
        ) : (
          <img
            src={selectedImage}
            onMouseOver={() => setSelectedImage(link.imageHover)}
            onMouseOut={() => setSelectedImage(link.image)}
            className={linkStyle}
            alt={link.imageAlt}
          />
        )}
      </a>
    </div>
  );
};

export default CustomLink;
